export class PromotionCampaign {
    constructor(promotionCampaign) {
        this.content = promotionCampaign ? promotionCampaign.content : '';
    }
}